/*
    The code editor will try and replace squirrely arrow functions with html encoded attributes
    for the "each" and "foreach" helpers as described here https://squirrelly.js.org/docs/syntax/builtin-helpers
    Therefore we use data attributes of the form
    

      data-each="each.array,name" is replaced with {{@each(it.array) => name, index}}
      data-foreach="array,keyname,valname" is replaced with {{@foreach(it.someobject) => key, val}}
    
  */
const injectSquirrelly = html => {
  const insertAfter = (newNode, referenceNode) => {
    const parentNode = referenceNode.parentNode;
    if (parentNode.lastChild === referenceNode) {
      // If the referenceNode is the last child, append the newNode at the end of the parent
      parentNode.appendChild(newNode);
    } else {
      // Otherwise, insert newNode before the next sibling of referenceNode
      parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
  };

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  let elements = doc.querySelectorAll(`[data-each]`);

  elements.forEach(element => {
    const value = element.getAttribute(`data-each`);
    const parts = value ? value.split(',') : [];

    if (!parts || parts.length !== 2) {
      return;
    }

    const wrapperContent = `{{@each(it.${parts[0].replace('it.', '')}) => ${
      parts[1]
    },index}}`;

    const wrapper = doc.createComment(wrapperContent);

    element.parentNode.insertBefore(wrapper, element);
    element.removeAttribute('data-each');

    const endTag = doc.createComment('{{/each}}');

    insertAfter(endTag, element.parentNode.lastChild);
  });

  /*
  elements = doc.querySelectorAll(`[data-foreach]`);

  elements.forEach(element => {
    const value = element.getAttribute(`data-foreach`);
    const parts = value ? value.split(',') : [];

    if (!parts || parts.length !== 2) {
      return;
    }

    const wrapper = doc.createComment(
      `{{@foreach(it.${parts[0]}) => key,${parts[1]}}}`
    );

    element.parentNode.insertBefore(wrapper, element);
    element.removeAttribute('data-foreach');

    const endTag = doc.createComment('{{/foreach}}');

    insertAfter(endTag, element.parentNode.lastChild);
  });
  */

  return doc.body.innerHTML.replace(/=&gt;/g, '=>');
};

export { injectSquirrelly };
